const PATIENT_ACCESS_SESSION_KEY = "patientAccessSession";
const PATIENT_ACCESS_SESSION_TTL_MS = 4 * 60 * 60 * 1000;

export const createPatientAccessSession = ({ appointmentId, patientId }) => {
  if (!appointmentId || !patientId) {
    return null;
  }

  const now = Date.now();
  const session = {
    appointmentId: String(appointmentId),
    patientId: String(patientId),
    grantedAt: now,
    expiresAt: now + PATIENT_ACCESS_SESSION_TTL_MS,
  };

  localStorage.setItem(PATIENT_ACCESS_SESSION_KEY, JSON.stringify(session));
  return session;
};

export const getPatientAccessSession = () => {
  try {
    const rawSession = localStorage.getItem(PATIENT_ACCESS_SESSION_KEY);

    if (!rawSession) {
      return null;
    }

    const session = JSON.parse(rawSession);

    if (
      !session?.appointmentId ||
      !session?.patientId ||
      !session?.expiresAt ||
      Date.now() > session.expiresAt
    ) {
      clearPatientAccessSession();
      return null;
    }

    return session;
  } catch (error) {
    clearPatientAccessSession();
    return null;
  }
};

export const hasPatientAccessForAppointment = (appointmentId) => {
  const session = getPatientAccessSession();

  if (!session || !appointmentId) {
    return false;
  }

  return session.appointmentId === String(appointmentId);
};

export const clearPatientAccessSession = () => {
  localStorage.removeItem(PATIENT_ACCESS_SESSION_KEY);
};
